{
  "title": "FBO-Aktivitätstracker",
  "comingSoonTitle": "Demnächst",
  "comingSoonDescription": "Diese Funktion zeigt die Aktivitätsverfolgung für jedes FBO-Konto an.",
  "fboAccountsTitle": "FBO-Konten ({{count}}):",
  "activityDataComingSoon": "Aktivitätsdaten folgen in Kürze"
}
